import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/rubicon.webp';
import screenshot_target from '../../../images/letterfunnel/derkvanderwoude.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Derk van der Woude"
      firstname="Derk"
      companyname="Rubicon"
      competition="InSpark en Fellowmind"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/derkvanderwoude.js